import type { components } from '@pba/types-openapi-client';

export type UploadedFile = {
  byteSize: number;
  checksum?: string;
  contentType: string;
  createdAt?: string;
  downloadUrl: string;
  filename: string;
  id: string;
  url: string;
};

export const createUploadedFile = (uploadedFile: components['schemas']['File']): UploadedFile => ({
  byteSize: uploadedFile.byte_size,
  checksum: uploadedFile.checksum,
  contentType: uploadedFile.content_type,
  createdAt: uploadedFile.created_at,
  downloadUrl: uploadedFile.download_url,
  filename: uploadedFile.filename,
  id: uploadedFile.id,
  url: uploadedFile.url,
});
